import { formatHold } from '../state/store'
import { ROW_DEFS } from '../state/types'
import type { RowKey, VoiceState } from '../state/types'

interface Props {
	state: VoiceState
	onToggle: () => void
	onEditRow: (key: RowKey, label: string) => void
}

/** Layer 3 — the pinned „Rendelés" panel: the durable contract of the
    conversation. Inline cards are moments; this panel is what the user keeps. */
export function SummaryPanel({ state, onToggle, onEditRow }: Props) {
	const count = Object.keys(state.sum).length
	return (
		<div className="am-panel-wrap">
			<div className="am-col">
				<div className="am-panel">
					<button type="button" className="am-panel-head" onClick={onToggle}>
						<span className={`am-panel-caret${state.expanded ? ' open' : ''}`}>▶</span>
						<span className="am-panel-title">Rendelés</span>
						<span className="am-panel-count">{count}/6 pont rögzítve</span>
						<span className="am-panel-spacer" />
						<span className="am-panel-total">{state.total}</span>
					</button>
					{state.expanded && (
						<div className="am-panel-body">
							{ROW_DEFS.map((d) => {
								const value = state.sum[d.key]
								return (
									<button
										type="button"
										key={d.key}
										className={`am-panel-row${value ? ' done' : ''}`}
										onClick={() => value && onEditRow(d.key, d.label)}
									>
										<span className="am-panel-mark">{value ? '✓' : '·'}</span>
										<span className="am-panel-label">{d.label}</span>
										<span className="am-panel-value">{value || 'még egyeztetjük'}</span>
										{value && !state.done && <span className="am-panel-edit">Módosít</span>}
									</button>
								)
							})}
							{state.holdOn && !state.done && (
								<div className="am-panel-hold">{formatHold(state.holdLeft)}</div>
							)}
						</div>
					)}
				</div>
			</div>
		</div>
	)
}
